import React, { useState } from "react";
import { Dialog, DialogFooter, Icon, Pivot, PivotItem } from "@fluentui/react";
import data from "./InfoPopUp.json";
import { InfoPanelInformation } from "../../../../app/components/main/Services/InfoPanelInformation";
import DWRHelpForm from "./DWRHelpForm";
import './CardModal.css';

interface CardModalProps {
    isVisible: boolean;
    onClose: () => void;
    cardDetails: { tileName: string; aboutService: string };
    defaultTab:any;
}

const CardModal: React.FC<CardModalProps> = ({ isVisible, onClose, cardDetails, defaultTab }) => {
    
    const [selectedKey, setSelectedKey] = useState<string>(defaultTab);
    
    return (
        <Dialog
            hidden={!isVisible}
            onDismiss={onClose}
            dialogContentProps={{
                title: '',
                subText: "",
            }}
            modalProps={{
                className: "custom-dialog",
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <h2 style={{ fontSize: "20px", margin: 0, fontWeight: "bold" }}>{cardDetails.tileName}</h2>
                <Icon
                    iconName="Cancel"
                    tabIndex={0}
                    onClick={onClose}
                    aria-label="close"
                    role="button"
                    styles={{ root: { cursor: 'pointer', padding: 5 } }}
                />
            </div>

            <Pivot selectedKey={selectedKey} onLinkClick={(item) => setSelectedKey(item?.props.itemKey || 'service')}>
                <PivotItem headerText="Service Info" itemKey="service">
                    <DialogFooter>
                        <InfoPanelInformation data={data[0]} />
                    </DialogFooter>
                </PivotItem>

                {cardDetails.tileName === "Digital Win Room (DWR) Help" && (
                    <PivotItem headerText={`${cardDetails.tileName} Form`} itemKey="form">
                        <div style={{ padding: '10px' }}>
                            <DWRHelpForm />
                        </div>
                    </PivotItem>
                )}
            </Pivot>
        </Dialog>
    );
};

export default CardModal;
